import api from './api';

export const getLogsApi = params => {
  return api.get('/logs', {params});
};

export const getCheckinsApi = params => {
  return api.get('/checkin', {params});
};

export const getCheckinsByCustomerApi = (customerId, params) => {
  return api.get(`/checkin/customer/${customerId}`, {params});
}

export const getInvalidStatusCardsApi = params => {
  return api.get('/checkin/compare-inactive-cards', {params});
};
